import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component is used to show contact person's name ,phone numbers and email
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails

    return (
        <div className="client_info d-flex">
            {IV1_PageDetails.ContactPersons.map((contact_person,key)=>{
                return(
                   <PersonDetail key={key + 'contact_person'} contact_person={contact_person.FirstName}
                                 phone={contact_person.Phone} email={contact_person.Mail}/>
                )
            })}
        </div>
    )
}
const PersonDetail = (props)=>{
    return(
    <div  className="d-flex">
        <b className="client_name">{props.contact_person} : - </b>
        <h6 className="phone_details">{props.phone? props.phone : "  Phone Not Available      "}
            <br/>{props.email? props.email :""} </h6> </div>
    )
}